import { render, staticRenderFns } from "./InfosParents.vue?vue&type=template&id=5a29de70"
import script from "./InfosParents.vue?vue&type=script&lang=js"
export * from "./InfosParents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports